jQuery(document).ready(function ($) {
  
  consoleMessage: {
    console.log('%cCreated by %cTWK%cwww.thewebkitchen.co.uk', 'background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;', 'background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;', 'background: #FFFFFF; padding: 5px 10px;');
  }

  modernizer: {
    if (!Modernizr.objectfit) {
      $('.object-fit').each(function () {
        var $container = $(this),
        imgUrl = $container.find('img').prop('src');
        if (imgUrl) {
          $container
          .css('backgroundImage', 'url(' + imgUrl + ')')
          .addClass('not-compatible');
        }
      });
    }
  }

  fixedheader: {
    $(function () {
      $(window).scroll(function () {
        if ($(window).scrollTop() >= 150) {
          $('.header').addClass('fixed-header');
        }
        if ($(window).scrollTop() >= 160) {
          $('.header').addClass("transform-none");
        }
        else {
          $('.header').removeClass('fixed-header');
          $('.header').removeClass("transform-none");
        }
      });
    });
  }

  search: {
      if (window.matchMedia('(min-width: 1140px)').matches) {
        $('.js-search').on('click', function (e) {
          $('.js-search-form').addClass('is-active');
          $('.menu-top-menu-container').addClass('search-active');
          $("#s").focus();
          setTimeout(function () {
            $('.close-search').fadeIn();
          }, 300);
        });
        $('.js-close-search').on('click', function (e) {
          $('.js-search-form').removeClass('is-active');
          $('.menu-top-menu-container').removeClass('search-active');
        });
      }

      $(window).resize(function () {
        if (window.matchMedia('(min-width: 1140px)').matches) {
          $('.js-search').on('click', function (e) {
            $('.js-search-form').addClass('is-active');
            $('.menu-top-menu-container').addClass('search-active');
            $("#s").focus();
            setTimeout(function () {
              $('.close-search').fadeIn();
            }, 300);
          });
          $('.js-close-search').on('click', function (e) {
            $('.js-search-form').removeClass('is-active');
            $('.menu-top-menu-container').removeClass('search-active');
          });
        }
      });

  }



  menu: {
    // Close menu on click outside

    $('body').bind("click touchstart", function(e) {
			if ( $(e.target).closest('.menu-wrapper').length === 0 &&  $(e.target).closest('.menu-button-wrapper').length === 0  ) {
        $('.menu-main-menu-container .menu-item').removeClass('transform-none');
        $('.menu-main-menu-container .menu-item .sub-menu-wrap').removeClass('transform-none');
        $('#top-menu-v2 .menu-item').removeClass('is-active');
        $('#top-menu-v2 .menu-item .sub-menu').removeClass('is-active');
			}
		});


    // Desktop menu
    $('.menu-main-menu-container .menu-item-has-children > a').click(function (event) {
      event.preventDefault();
      if ( $(this).parent().hasClass('transform-none') ) {
        // If current link has transform-none class, don't add the class back
        $('.menu-main-menu-container .menu-item').removeClass('transform-none');
        $('.menu-main-menu-container .menu-item .sub-menu-wrap').removeClass('transform-none');
        $('#top-menu-v2 .menu-item').removeClass('is-active');
        $('#top-menu-v2 .menu-item .sub-menu').removeClass('is-active');
      } else {
        $('.menu-main-menu-container .menu-item').removeClass('transform-none');
        $('.menu-main-menu-container .menu-item .sub-menu-wrap').removeClass('transform-none');
        $('#top-menu-v2 .menu-item').removeClass('is-active');
        $('#top-menu-v2 .menu-item .sub-menu').removeClass('is-active');
        $(this).parent().addClass('transform-none');
        $(this).parent().children('li .sub-menu-wrap').addClass('transform-none');

        if (window.matchMedia('(min-width: 1140px)').matches) {
          // Menu timeline
          var menuTL = gsap.timeline({delay: 0.15,});
          var menuImgWrapper = $(this).parent().find('.menu-image-wrapper');
          var menuImg = $(this).parent().find('.menu-image');
          var textWrapper = $(this).parent().find('.split-text-contain');
          var text = $(this).parent().find('.split-bg-title__line');


          menuTL.fromTo(menuImgWrapper, {xPercent:-100}, {duration: 0.55, xPercent:0}, {ease:'easeInQuad'});
          menuTL.fromTo(menuImg,{xPercent:100}, {duration: 0.55, xPercent:0}, {ease:'easeInQuad'});

          menuTL.fromTo(textWrapper, {xPercent:-100}, {duration: 0.55, delay: 0.25, xPercent:0}, {stagger:2, ease:'easeInQuad'});
          menuTL.fromTo(text, {xPercent:100}, {duration: 0.55, delay: 0.25, xPercent:0}, {stagger:2, ease:'easeInQuad'});
        }
      }
    });

    // Mobile menu
    var $mobileMenu = $(".mobile-menu-button");
    $mobileMenu.on("click", function(e) {
      $mobileMenu.toggleClass("is-active");
      $('.mobile-menu-button-wrapper').toggleClass('is-active');
      $('.menu-wrapper').toggleClass('is-active');
      if ( $('.top-nav .menu-wrapper .sub-menu-wrap').hasClass('is-active') ) {
        $('.mobile-menu-button-wrapper').removeClass('submenu-active');
        $('.top-nav .menu-wrapper .sub-menu-wrap').removeClass('is-active');
      }

      // Open sub-nav on click on menu item with children
      $(".menu-main-menu-container .menu-item-has-children > a").on("click", function(e) {
        e.preventDefault();
        $(this).parent().find('.sub-menu-wrap').toggleClass('is-active');
        $('.mobile-menu-button-wrapper').addClass('submenu-active');
      });
      // Close sub-nav on click on back button
      $(".menu-main-menu-container .menu-item-has-children .back-menu").on("click", function(e) {
        e.preventDefault();
        $(this).parent().parent().toggleClass('is-active');
        $('.mobile-menu-button-wrapper').removeClass('submenu-active');
      });
    });

    // Top Links menu Desktop 
    $('#top-menu-v2 .menu-item-has-children > a').click(function(event){
      event.preventDefault();
      if ( $(this).parent().hasClass('is-active') ) {
        // If current link has transform-none class, don't add the class back
        $('#top-menu-v2 .menu-item').removeClass('is-active');
        $('#top-menu-v2 .menu-item .sub-menu').removeClass('is-active');
      } else {
        $('#top-menu-v2 .menu-item').removeClass('is-active');
        $('#top-menu-v2 .menu-item .sub-menu').removeClass('is-active');
        $('.menu-main-menu-container .menu-item').removeClass('transform-none');
        $('.menu-main-menu-container .menu-item .sub-menu-wrap').removeClass('transform-none');
        $(this).parent().addClass('is-active');
        $(this).parent().children('li .sub-menu').addClass('is-active');
      }

    });

  }

anchorlinks: {
  $(document).on('click', '.scroll-to', function (event) {
    event.preventDefault();

    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
  });

  $('.js-scroll-next').on('click', function(event){
	event.preventDefault();

    $('html, body').animate({
      scrollTop: window.innerHeight
    }, 500);
  });
}

scrollTopNextArrow: {
	let scrollTop = $(window).scrollTop();
	$( '.js-scroll-top' ).removeClass('active');
	//$( '.js-scroll-next' ).addClass('active');  // it added with the homepage animation gsap timeline

	$(window).on( 'scroll', function(){
		scrollTop = $(window).scrollTop();

		if ( scrollTop >  window.innerHeight / 2) {
			$( '.js-scroll-top' ).addClass('active');
			$( '.js-scroll-next' ).removeClass('active');
		} else {
			$( '.js-scroll-top' ).removeClass('active');
			$( '.js-scroll-next' ).addClass('active');
		}
	});
}

externallinks: {
  $('a[href^="mailto:"]').each(function () {
    $(this).addClass('email-link');
  });

  $('a:not(.email-link):not([class^="magnific-"])').each(function () {
    var a = new RegExp('/' + window.location.host + '/');

    if (!a.test(this.href)) {
      $(this).click(function (event) {
        event.preventDefault();
        window.open(this.href, '_blank');
      });
    }
  });
  pdfs: {
    // Open PDFs in new window
    $(function () {
      $('a[href$=".pdf"]').prop('target', '_blank');
    });
  }
}

// Background title - split text
const splitBgTitle = new SplitText('.title-bg', {type: 'lines', linesClass: "split-bg-title__line line++"});
$(".split-bg-title__line").wrap("<div class='split-text-contain'></div>");
$(".split-bg-title__line").wrapInner("<span></span>");

bannerAnimations: {
  if ( $('.banner').length ) {
    // Banner timeline
    var bannerTl = gsap.timeline({delay: 0.8});
	bannerTl.to( '.banner__content', { duration: 0.5, opacity: 1 } )
    bannerTl.fromTo('.banner__content .split-text-contain', {xPercent:-100}, {duration: 0.55, xPercent:0}, {stagger:2, ease:'easeInQuad'});
    bannerTl.fromTo('.banner__content .split-bg-title__line',{xPercent:100}, {duration: 0.55, xPercent:0}, {stagger:2, ease:'easeInQuad'});
  }
}

buttonEffects: {
    $('.button').each( function(i) {
      // Get width of button and round up to nearest 100
      var buttonWidth = $(this).innerWidth();
      //console.log(buttonWidth);
      var buttonWidthRounded = Math.ceil(buttonWidth/100)*100;
      

      // Add wrappers to make hover function work
      $(this).wrap('<div class="button-wrapper button-width-' + buttonWidthRounded + '"></div>');
      $(this).wrapInner('<span class="button--text"></span>');
      $(this).parent().prepend('<span class="button--circle"></span>');
    });


    // Hover effect
    $( ".button" ).mouseenter(function(e) {
      var parentOffset = $(this).offset();
      var relX = e.pageX - parentOffset.left;
      var relY = e.pageY - parentOffset.top;

      $(this).prev(".button--circle").css({"left": relX, "top": relY });
      $(this).prev(".button--circle").removeClass("desplode-circle");
      $(this).prev(".button--circle").addClass("explode-circle");
    });

    $( ".button" ).mouseleave(function(e) {
      var parentOffset = $(this).offset();
      var relX = e.pageX - parentOffset.left;
      var relY = e.pageY - parentOffset.top;

      $(this).prev(".button--circle").css({"left": relX, "top": relY });
      $(this).prev(".button--circle").removeClass("explode-circle");
      $(this).prev(".button--circle").addClass("desplode-circle");
    });

    // https://codepen.io/animationbro/details/dyoVQRz
}


slider: {
  $('.news-slider__images').slick({
    dots: true,
    arrows: false,
    fade: false,
    autoplay: false,
    autoplaySpeed: 4500,
    asNavFor: '.news-slider__text',
    slidesToShow: 1,
    slidesToScroll: 1,
  });
  $('.news-slider__text').slick({
    dots: false,
    arrows: false,
    fade: false,
    autoplay: false,
    autoplaySpeed: 4500,
    asNavFor: '.news-slider__images',
    slidesToShow: 1,
    slidesToScroll: 1,
    focusOnSelect: true,
  });

  $('.house-image-slider').slick({
    dots: false,
    arrows: true,
    slidesToShow: 2,
    nextArrow: $('.house-slider-arrows .next'),
    prevArrow: $('.house-slider-arrows .prev'),
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
  });


  $('.timeline-slider__content').slick({
    infinite: false,
    dots: false,
    arrows: false,
    fade: true,
    autoplay: false,
    autoplaySpeed: 4500,
    asNavFor: '.timeline-slider__images, .timeline-slider__timeline, .timeline-slider__faded',
    slidesToShow: 1,
    slidesToScroll: 1,
    //focusOnSelect: true,
  });
  $('.timeline-slider__images').slick({
    infinite: false,
    dots: false,
    arrows: false,
    fade: false,
    autoplay: false,
    autoplaySpeed: 4500,
    asNavFor: '.timeline-slider__content, .timeline-slider__timeline, .timeline-slider__faded',
    slidesToShow: 1,
    slidesToScroll: 1,
  });
  $('.timeline-slider__faded').slick({
    infinite: false,
    dots: false,
    arrows: false,
    fade: false,
    autoplay: false,
    autoplaySpeed: 4500,
    asNavFor: '.timeline-slider__content, .timeline-slider__timeline',
    slidesToShow: 1,
    slidesToScroll: 1,
  });
  $('.timeline.timeline--desktop .timeline-slider__timeline').slick({
    infinite: false,
    dots: false,
    arrows: false,
    fade: false,
    autoplay: false,
    autoplaySpeed: 4500,
    asNavFor: '.timeline-slider__images, .timeline-slider__content, .timeline-slider__faded',
    slidesToShow: 9,
    slidesToScroll: 1,
    focusOnSelect: true,
    centerMode: true,
    centerPadding: '10%',
  });
  $('.timeline.timeline--mobile .timeline-slider__timeline').slick({
    infinite: false,
    dots: false,
    arrows: false,
    fade: false,
    autoplay: false,
    autoplaySpeed: 4500,
    asNavFor: '.timeline-slider__images, .timeline-slider__content, .timeline-slider__faded',
    slidesToShow: 9,
    slidesToScroll: 1,
    focusOnSelect: true,
    centerMode: true,
    centerPadding: '10%',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          centerPadding: '-3%',
          /*arrows: true,
          nextArrow: $('.timeline-arrows .next'),
          prevArrow: $('.timeline-arrows .prev'),*/
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding: '-3%',
          /*arrows: true,
          nextArrow: $('.timeline-arrows .next'),
          prevArrow: $('.timeline-arrows .prev'),*/
        }
      }
    ]
  });
  var historyContainer = $('.history-timeline .container').width();
  var halfWidth = historyContainer / 2;
  $('.timeline-slider__timeline .slick-track').css('margin-left', "-" + halfWidth + 'px');

  $('.js-back-to-start').on('click', function (e) {
    e.preventDefault();
    $('.timeline-slider__images').slick("slickGoTo", 0);
  });


  /**
  * Gallery slider with thumbnails navigation.
  */
  var status = $('.gallery-slider__full-nav .pages');
  var slickElement = $('.gallery-slider__full');

  slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    status.text(i + ' of ' + slick.slideCount);
  });

  $('.gallery-slider__full').slick({
    dots: false,
    arrows: true,
    fade: true,
    asNavFor: '.gallery-slider__thumb',
    appendArrows: '.gallery-slider__full-nav',
  });
  $('.gallery-slider__thumb').slick({
    dots: false,
    arrows: true,
    slidesToShow: 4,
    // centerMode: true,
    focusOnSelect: true,
    asNavFor: '.gallery-slider__full',
  });
}

magnific: {
  // IFRAME
  $('.magnific-video').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,

    iframe: {
      markup: '<div class="mfp-iframe-scaler">' +
      '<div class="mfp-close"></div>' +
      '<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
      '</div>',
      patterns: {
        youtu: {
          index: 'youtu.be',
          id: function( url ) {

            // Capture everything after the hostname, excluding possible querystrings.
            var m = url.match( /^.+youtu.be\/([^?]+)/ );

            if ( null !== m ) {
              return m[1];
            }

            return null;

          },
          // Use the captured video ID in an embed URL.
          // Add/remove querystrings as desired.
          src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0'
        },
        youtube: {
          index: 'youtube.com/',
          id: 'v=',
          src: 'https://www.youtube.com/embed/%id%?autoplay=1'
        }
      }
    }
  });


  // INLINE
  $('.magnific-inline-popup').magnificPopup({
    type: 'inline',

    fixedContentPos: false,
    fixedBgPos: true,

    overflowY: 'auto',

    closeBtnInside: true,
    preloader: false,

    midClick: true,
    removalDelay: 300,
    mainClass: 'my-mfp-zoom-in'
  });


  // GALLERY SINGLE IMAGE
  $('.magnific-gallery-single-image').magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    mainClass: 'mfp-img-single',
    image: {
      verticalFit: true,
      titleSrc: function titleSrc(item) {
        return item.el.attr('title');
      }
    },
    gallery: {
      enabled: false
    }
  });

  // GALLERY IMAGE
  $('.magnific-gallery-image').magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    mainClass: 'mfp-img-mobile',
    image: {
      verticalFit: true,
      titleSrc: function(item) {
        return item.el.attr('title');
      }
    },
    gallery:{
      enabled:true
    }
  });
}

accordion: {
  if ($('.block--accordion').length) {

    $( '.accordion__content--wrapper' ).css('display', 'none'); // All items closed.

    $('.block--accordion').find('.js-accordion-trigger').on('click', function() {

      // Close only the items in this accordion.
      $(this).parent().siblings().find('.js-accordion-trigger').next().slideUp('fast'); // reset
      $(this).parent().siblings().find('.js-accordion-trigger').removeClass('open');    // reset




      // Close items in all accordions on the page.
      //$('.js-accordion-trigger').not(this).next().slideUp('fast'); // reset
      //$('.js-accordion-trigger').not(this).removeClass('open');    // reset

      if ($(this).hasClass('open')){
        $(this).next().slideUp('fast');
        $(this).removeClass('open');
      } else {
        //$(this).next().slideDown('fast');
        $(this).next().slideDown( 'fast', function () {
          $('html,body').animate({
            scrollTop: $(this).offset().top-80
          }, 500)
       });
        $(this).addClass('open');
      }

    });
  }
}


tabs: {
  const tabs = document.querySelectorAll('[role="tab"]');
  const tabList = document.querySelector('[role="tablist"]');

  if ( tabs ) {

    // Add a click event handler to each tab
    tabs.forEach(tab => {
      tab.addEventListener("click", changeTabs);
    });

    // Enable arrow navigation between tabs in the tab list
    let tabFocus = 0;

    if ( tabList ) {
      tabList.addEventListener("keydown", e => {
        // Move right
        if (e.keyCode === 39 || e.keyCode === 37) {
          tabs[tabFocus].setAttribute("tabindex", -1);
          if (e.keyCode === 39) {
            tabFocus++;
            // If we're at the end, go to the start
            if (tabFocus >= tabs.length) {
              tabFocus = 0;
            }
            // Move left
          } else if (e.keyCode === 37) {
            tabFocus--;
            // If we're at the start, move to the end
            if (tabFocus < 0) {
              tabFocus = tabs.length - 1;
            }
          }

          tabs[tabFocus].setAttribute("tabindex", 0);
          tabs[tabFocus].focus();
        }
      });
    }

    function changeTabs(e) {
      console.info('tabs clicked');
      const target = e.target;
      const parent = target.parentNode;
      const grandparent = parent.closest('.tabs');


      console.info(grandparent);
      // Remove all current selected tabs
      parent
        .querySelectorAll('[aria-selected="true"]')
        .forEach(t => t.setAttribute("aria-selected", false));

      // Set this tab as selected
      target.setAttribute("aria-selected", true);

      // Hide all tab panels
      grandparent
        .querySelectorAll('[role="tabpanel"]')
        .forEach(p => p.setAttribute("hidden", true));

      // Show the selected panel
      grandparent.parentNode
        .querySelector(`#${target.getAttribute("aria-controls")}`)
        .removeAttribute("hidden");

        $('.button').each( function(i) {
          // Get width of button and round up to nearest 100
          var buttonWidth = $(this).innerWidth();
          //console.log(buttonWidth);
          var buttonWidthRounded = Math.ceil(buttonWidth/100)*100;
          
          $('.button-wrapper').removeClass('button-width-0');
          $('.button-wrapper').addClass('button-width-' + buttonWidthRounded);
    
        });

        
    }

  }
}

scrollTabs: {
  $(document).on('click', '.scroll-tabs__tab', function (event) {
    event.preventDefault();
    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
  });


  $(window).scroll(function () {
    var scrollTop = $(document).scrollTop();
    var anchors = $('body').find('.scroll-tabs__panel');


    for (var i = 0; i < anchors.length; i++) {
      if (scrollTop > $(anchors[i]).offset().top - 172 && scrollTop < $(anchors[i]).offset().top + $(anchors[i]).height() - 172) {
        $('.scroll-tabs__tab[href="#' + $(anchors[i]).attr('id') + '"]').addClass('active');
      } else if ( scrollTop < $('#panel-1').offset().top ) {
        $('.scroll-tabs__tab[href="#' + $('#panel-1').attr('id') + '"]').addClass('active');
      } else {
        $('.scroll-tabs__tab[href="#' + $(anchors[i]).attr('id') + '"]').removeClass('active');
      }
    }

  });
}


iframes: {
    $('iframe[src*="vimeo.com"]').wrap('<div class="iframe-wrapper"></div>');
    $('iframe[src*="youtube.com"]').wrap('<div class="iframe-wrapper"></div>');
  }

tables: {
  $('table').wrap('<div class="table-wrapper"></div>');
  setTimeout(function () {
    $('.dataTables_filter input').attr('placeholder', 'Search...');
  }, 50);

  $(document).on("sf:ajaxfinish", ".searchandfilter", function(){
    console.log("ajax complete");
    //so load your lightbox or JS scripts here again
    $('table').wrap('<div class="table-wrapper"></div>');
  });

}

ajaxStories: {

  $('.student-stories-section .load-more').on('click', function(e) {
    e.preventDefault();
    $(this).addClass('disabled');

    $.ajax({
      type: 'GET',
      url: php_vars.ajaxUrl,
      dataType: 'html',
      data: {
        action: 'more_ajax_stories',
        //mode: 'POST',
      },
      success: function success(html) {
        $('.home .ajax-story-wrapper').append(html);
        const splitBgTitle = new SplitText('.ajax-student-profile .title-bg', {type: 'lines', linesClass: "split-bg-title__line line++"});
        $(".split-bg-title__line").wrap("<div class='split-text-contain'></div>");
        $(".split-bg-title__line").wrapInner("<span></span>");
      },
      error: function error(_error) {
        console.error(_error);
      }
    });
  })

}

stickySocial: {
  var $sticky = $('.sticky-share');
  var $stickyrStopper = $('.sticky-stopper');
  if (!!$sticky.offset()) { // make sure ".sticky" element exists

    var generalSidebarHeight = $sticky.innerHeight();
    var stickyTop = $sticky.offset().top;
    var stickOffset = 20;
    var stickyStopperPosition = $stickyrStopper.offset().top;
    var stopPoint = stickyStopperPosition - generalSidebarHeight - stickOffset;
    var diff = stopPoint + stickOffset;

    $(window).scroll(function(){ // scroll event
      var windowTop = $(window).scrollTop(); // returns number

      if (stopPoint < windowTop) {
          $sticky.css({ position: 'absolute', top: diff });
      } else if (stickyTop < windowTop+stickOffset) {
          $sticky.css({ position: 'fixed', top: stickOffset });
      } else {
          $sticky.css({position: 'absolute', top: 'inherit'});
      }
    });

  }

}

loadingAnimations: {
  $.fn.isOnScreen = function () {
    var win = $(window);
    var viewport = {
      top: win.scrollTop()
    };
    viewport.bottom = viewport.top + win.height() - 80;

    var bounds = this.offset();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.bottom < bounds.top || viewport.top > bounds.bottom));
  };

  // First load Animation
  $('.off-screen').each(function (index) {
    if ($(this).isOnScreen()) {
      $(this).removeClass('off-screen--hide');
    }
  });

  // Animation on scroll
  $(window).scroll(function () {
    $('.off-screen').each(function (index) {
      if ($(this).isOnScreen()) {
        $(this).removeClass('off-screen--hide');
      }
    });
  });
}


loadingAnimationsGsap: {
	let twkAosTrigger;
	let twkAosMarker;

	$('[twk-aos]').each(function () {

		if ( $(this).attr('twk-aos-trigger') !== undefined ){
			twkAosTrigger = $(this).attr('twk-aos-trigger');
		} else {
			twkAosTrigger  = 'bottom-=150px';
		}
		//console.log( twkAosTrigger );

		if ( $(this).attr('twk-aos-marker') ){
			twkAosMarker = true;
		} else {
			twkAosMarker = false;
		}
		//console.log(twkAosMarker);

		ScrollTrigger.create({
			trigger: $(this),
			start: "top "+ twkAosTrigger,
			end: "bottom bottom",
			markers: twkAosMarker,
			onEnter: () => $(this).addClass( 'twk-aos-animate'),
		});
	});
}
});
